const styles = theme => ({
  containerEquipFilters: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  boxDescription: {
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column',
    width: '180px',
  },
  descriptionText: {
    padding: '0px',
    fontSize: '12px',
    fontWeight: 500,
  },
  filterMenu: {
    backgroundColor: theme.palette.common.white,
    borderRadius: '8px',
    margin: '5px 0 0 0',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px',
    boxShadow: 'none',
    width: '100%',
  },
  autocompletePaperMargin: {
    marginTop: '60px',
    zIndex: '1200px',
    overflow: 'auto',
    width: 'max-content',
    maxWidth: '350px',
  },
});

export default styles;
